import { useParams } from 'react-router-dom'

import useOrganization from '../hooks/useOrganization'

import Layout from '@/gf/components/Layout'
import Page from '@/gf/components/Page'
import Frame from '../components/Frame'
import LatestOrderCard from './Account/LatestOrderCard'
import PricingCard from './Account/PricingCard'

const Account = () => {
  const orgId = (useParams<{ id: string }>() as { id: string }).id
  const org = useOrganization({ id: orgId }).data?.customerOrganization

  const breadcrumbs = {
    copy: 'Back to Dashboard',
    crumbs: [
      { name: 'Accounts', href: '/accounts' },
      { name: 'Account details', href: `/accounts/${orgId}` },
    ],
  }

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title={org?.name || <>&hellip;</>}>
        <Layout>
          <Layout.Section type="primary">
            <LatestOrderCard />
          </Layout.Section>
          <Layout.Section type="secondary">
            <PricingCard orgId={orgId} />
          </Layout.Section>
        </Layout>
      </Page>
    </Frame>
  )
}

export default Account
